import PropTypes from 'prop-types';
import LiveAdminModulePage from './LiveAdminModulePage';
import { moduleRegistry } from '../../admin/moduleRegistry';
import { AdminModulePlaceholder, AdminScreenLayout } from '../../sections/admin/shared';

export default function AdminModulePage({ moduleKey }) {
  const module = moduleRegistry[moduleKey];

  if (!module) {
    return null;
  }

  if (module.mode === 'refactored') {
    return <LiveAdminModulePage moduleKey={moduleKey} />;
  }

  return (
    <AdminScreenLayout title={module.title}>
      <AdminModulePlaceholder module={module} />
    </AdminScreenLayout>
  );
}

AdminModulePage.propTypes = {
  moduleKey: PropTypes.string.isRequired,
};
